import React, { createContext, useState } from 'react';

export const TopMenuOptionContext = createContext({
  menuOption: {
    value: ''
  },
  setMenuOption: () => {}
});

export default function TopMenuOptionProvider({ children }) {
  const [menuOption, setMenuOption] = useState({
    value: ''
  });

  return (
    <TopMenuOptionContext.Provider value={{ menuOption, setMenuOption }}>
      {children}
    </TopMenuOptionContext.Provider>
  );
}
